import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Typography,
  InputAdornment,
  IconButton,
  Link as MUILink,
  Paper,
  Fade,
} from "@mui/material";
import { AuthContext } from "./../AuthContext/AuthContext";
import { Visibility, VisibilityOff, Lock } from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import { BASE_URL, Notification_Url } from "./../Api/ApiUrls";


import Property_pincoder from "./../../../src/Images/property_pincode_new.png";
const Login = () => {
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login, guestLogin, userId, sessionId } = useContext(AuthContext);


useEffect(() => {
  if (userId && sessionId) {
    navigate("/dashboard");
  }
}, [userId, sessionId, navigate]);


  const handleGuestLogin = () => {
    guestLogin();
    navigate("/dashboard", {
      state: { isGuest: true },
    });
  };

  useEffect(() => {
    console.log("Initial fcmToken from window:", window.fcmToken);
  }, []);

  const checkHasActiveFreePlan = async (userId) => {
    try {
      const res = await fetch(`${BASE_URL}/Get-all-plan/${userId}/`);
      const plans = await res.json();

      if (!Array.isArray(plans)) return false;

      return plans.some(
        (plan) =>
          plan.plan_name === "Free" &&
          plan.status === true &&
          new Date(plan.expired_date) > new Date(),
      );
    } catch (err) {
      console.error("Check plan failed", err);
      return false;
    }
  };

  const autoSubscribeFreePlan = async (userId) => {
    try {
      await fetch(`${BASE_URL}/subscribe/free/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: userId,
          plan_name: "Free",
          // trial_days: 365,
        }),
      });
      return true;
    } catch (err) {
      console.error("Auto subscribe failed", err);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const cleanIdentifier = identifier.trim();
    const cleanPassword = password.trim();

    if (!cleanIdentifier || !cleanPassword) {
      setError("Mobile number / Email and password are required");
      return;
    }
  setLoading(true); 
    try {
      const response = await fetch(`${BASE_URL}/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          identifier: cleanIdentifier,
          password: cleanPassword,
        }),
      });

      const data = await response.json();

      console.log("Login Data=", data);

      if (!response.ok) {
  if (data.error === "Invalid Identifier.") {
    setError("Invalid Email/Mobile number.");
  } else {
    setError(data.error || "Invalid credentials");
  }
  return;
}

      // ✅ SAVE LOGIN
      login(data.user_id, data.session_token);

        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("session_token", data.session_token);

      // ✅ 🔥 ADD THIS BLOCK
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            user_id: data.user_id,
            session_token: data.session_token,
            username: data.username,
          }),
        );
      }

       // 🔥 CHECK TERMS AFTER LOGIN (SECURE WAY)
    const userRes = await fetch(
      `${BASE_URL}/users/${data.user_id}/`,
      {
        headers: {
          "Authorization": `Bearer ${data.session_token}`,
        },
      }
    );

    const userData = await userRes.json();

    if (!userData.tersm_and_condition) {
      // 🚀 Redirect to Terms page
      navigate("/termsandconditions", {
        state: { fromLogin: true },
      });
      return;
    }

      const userId = data.user_id;

      // ✅ CHECK IF FREE PLAN EXISTS
      const hasFreePlan = await checkHasActiveFreePlan(userId);

      let showPopup = false;

      // ✅ APPLY FREE PLAN ONLY IF NOT EXISTS
      if (!hasFreePlan) {
        const subscribed = await autoSubscribeFreePlan(userId);
        if (subscribed) {
          showPopup = true;
          localStorage.setItem(`free_plan_popup_shown_${userId}`, "true");
        }
      }

      navigate("/dashboard", {
        state: {
          showFreePlanPopup: showPopup,
        },
      });
      // navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again later.");
     } finally {
    setLoading(false); // ✅ ALWAYS STOP LOADING
  } };

  return (
    <Fade in timeout={700}>
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #0d0d25, #000)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
        }}
      >
        <Container maxWidth="xs">
          <CssBaseline />
          <Paper
            elevation={10}
            sx={{
              p: 4,
              borderRadius: 4,
              background: "rgba(255, 255, 255, 0.02)",
              border: "1px solid rgba(255, 215, 0, 0.3)",
              backdropFilter: "blur(10px)",
              textAlign: "center",
              color: "#fff",
            }}
          >
            <Box
              component="img"
              src={Property_pincoder} // Make sure this variable is properly imported
              alt="Land Nest Logo"
              sx={{
                width: 180,
                height: 130,
                mb: 2,
                mx: "auto",
                borderRadius: 2,
                boxShadow: "0 0 20px #ffd700",
                display: "block",
              }}
            />
            <Typography
              variant="h5"
              sx={{ color: "#f7e896", fontWeight: 600, mb: 2 }}
            >
              Welcome Back
            </Typography>

            {error && (
              <Typography color="error" sx={{ fontSize: 14, mb: 2 }}>
                {error}
              </Typography>
            )}

            <Box component="form" onSubmit={handleSubmit}>
              {/* ✅ EMAIL OR MOBILE (SPACES ALLOWED) */}
              <TextField
                margin="normal"
                required
                fullWidth
                label="Mobile Number or Email"
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value.toLowerCase())}
                InputProps={{
                  sx: {
                    backgroundColor: "rgba(255,255,255,0.05)",
                    borderRadius: 2,
                    color: "white",
                  },
                }}
                InputLabelProps={{ style: { color: "#ccc" } }}
              />

              {/* ✅ PASSWORD */}
              <TextField
                margin="normal"
                required
                fullWidth
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  sx: {
                    backgroundColor: "rgba(255,255,255,0.05)",
                    borderRadius: 2,
                    color: "white",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{ color: "rgb(248, 227, 111)" }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { color: "#ccc" } }}
              />

              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                    sx={{ color: '#f7e896' }}
                  />
                }
                label={<Typography variant="body2" sx={{ color: '#ccc' }}>Remember me</Typography>}
              /> */}

       <Button
  type="submit"
  fullWidth
  variant="contained"
  disabled={loading}
  startIcon={!loading && <Lock />}
  sx={{
    mt: 2,
    mb: 2,
     background: "linear-gradient(135deg, #f1e57c, #e6ce45)",
    color: "#000",
    fontWeight: "bold",
  }}
>
  {loading ? (
    <CircularProgress size={24} sx={{ color: "#000" }} />
  ) : (
    "Sign In"
  )}
</Button>


              <Button
  variant="contained"
  onClick={handleGuestLogin}
  sx={{
    mt: 3,
    mb: 2,
    px: 2, // horizontal padding
    background: "linear-gradient(135deg, #888, #aaa)",
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center", // center inside flex column
    width: "auto", // size based on content
    "&:hover": {
      background: "linear-gradient(135deg, #ffe85c, #f0d53e)",
    },
  }}
>
  Continue as Guest
</Button>
              <Box display="flex" justifyContent="space-between">
                <MUILink
                  component={Link}
                  to="/register"
                  variant="body2"
                  sx={{ color: "rgb(250, 225, 85)" }}
                >
                  Create account
                </MUILink>
                <MUILink
                  component={Link}
                  to="/forgot"
                  variant="body2"
                  sx={{ color: "rgb(250, 228, 101)" }}
                >
                  Forgot password?
                </MUILink>
              </Box>

              <Box
                display="flex"
                justifyContent="center"
                flexWrap="wrap"
                gap={2}
                sx={{ mt: 3 }}
              >
                <MUILink
                  component={Link}
                  to="/termsandconditions"
                  variant="caption"
                  sx={{ color: "#ccc", textDecoration: "underline" }}
                >
                  Terms & Conditions
                </MUILink>
                <MUILink
                  component={Link}
                  to="/privacypolicy"
                  variant="caption"
                  sx={{ color: "#ccc", textDecoration: "underline" }}
                >
                  Privacy Policy
                </MUILink>
                <MUILink
                  component={Link}
                  to="/refundpolicy"
                  variant="caption"
                  sx={{ color: "#ccc", textDecoration: "underline" }}
                >
                  Refund Policy
                </MUILink>
              </Box>
            </Box>
          </Paper>
        </Container>
      </Box>
    </Fade>
  );
};

export default Login;
